import { render, staticRenderFns } from "./Snackbar.vue?vue&type=template&id=7464b996&scoped=true"
import script from "./Snackbar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Snackbar.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./Snackbar.vue?vue&type=style&index=0&id=7464b996&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7464b996",
  null
  
)

export default component.exports